import { Routes } from '@common/constants';

export const CATEGORY_IDS = ['rooms', 'rates', 'spa', 'dining'] as const;

export const CATEGORY_ROUTES: Record<string, string> = {
  rooms: Routes.ROOM_LIST,
  rates: Routes.RATE_LIST,
  spa: Routes.SPA_DAY_LIST,
  dining: Routes.TABLES_HOME,
};
